import { FC } from "react";
import AppLayout from "../../components/layout/app-layout/app-layout";
import { useTranslation } from "react-i18next";
import { ReactComponent as EyeIcon } from '../../assets/svg/openedEyeIcon.svg';
import { PagePublishedBidRequestsList } from "./page-published-bid-requests-list/page-published-bid-requests-list";
import TedTable from "./TedTable/TedTable";
import { useSharedTenderFilter } from "../app-tender-watch/useSharedTenderFilter";
import appState from "../../state/AppStateContainer";
import styles from "./page-public-bid-request-list.module.scss";

const PagePublicBidRequestList: FC = () => {
  const [t] = useTranslation('requests');
  // The public tenders add-on opens the TED tab alone; the private tab and its paywall come with SALES.
  const showsPrivate = appState.isSalesActive();
  const tenderFilter = useSharedTenderFilter(!showsPrivate);
  const pageTitle = showsPrivate
    ? t('published.pageTitle', 'Publicerade förfrågningar')
    : t('published.pageTitlePublicTenders', 'Offentliga upphandlingar');

  return (
    <AppLayout title={<div style={{ display: 'flex', gap: '8px', alignItems: 'center', }}><div style={{ borderRadius: '6px', backgroundColor: 'var(--gray-700)', width: '40px', height: '40px', position: 'relative', }}><EyeIcon style={{ fill: 'white', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} /></div><span>{pageTitle}</span></div>}>
      {showsPrivate
        ? <PagePublishedBidRequestsList />
        : <div className={styles.tendersOnly}><TedTable filter={tenderFilter} /></div>}
    </AppLayout>
  );
}

export default PagePublicBidRequestList;
